<template>
    <card-normal
        :class="{
            'email-card': true,
            'email-card--active': props.active,
        }"
        without-padding
        :border-color="props.active ? 'primary' : 'gray-200'"
        background-color="white"
        style="border-width: 2px"
    >
        <flex-container
            direction="column"
            :padding="Size.sm"
            :gap="Size.md"
        >
            <flex-container
                justify-content="space-between"
                align-items="center"
                :gap="Size.sm"
                no-wrap
            >
                <chip-label
                    color="turquoise-500"
                >
                    <svg-icon
                        :icon="EnvelopeIcon"
                        is-custom-icon
                        :size="IconSize.sm"
                    />
                </chip-label>
                <text-decorator
                    :size="FontSize.xs"
                    weight="medium"
                    class="email-card__title"
                >
                    {{ email.subject }}
                </text-decorator>
                <text-decorator :size="FontSize.xs" style="margin-left: auto;">
                    {{ formatDayTime(email.createdAt) }}
                </text-decorator>
            </flex-container>
            <flex-container align-items="center" :gap="Size.sm">
                <text-decorator :size="FontSize.xs">
                    {{ email.senderName }}
                </text-decorator>
                <div class="email-card__dot" />
                <text-decorator :size="FontSize.xs">
                    {{ email.recipient }}
                </text-decorator>
            </flex-container>
        </flex-container>
    </card-normal>
</template>

<script setup lang="ts">
    import EnvelopeIcon from '@keyvue/one-awesome-icons/icons/regular/envelope.svg?component';
    import type { Assistent, ChatEmail } from '@keyvue/one-api-client';
    import { FontSize, IconSize, Size } from '@keyvue/one-ui';
    import { formatDayTime } from '@/shared/utils/date';

    const props = defineProps<{
        assistent: Assistent,
        email: ChatEmail,
        mailCount?: number,
        active?: boolean,
        favorited?: boolean,
    }>();
</script>

<style scoped lang="scss">
.email-card {
    cursor: pointer;

    &__title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    &--active {
        @include box-shadow-360();
    }

    &__dot {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: color(gray-400);
    }
}
</style>
